var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable } from "mobx";
import CaseTypesStore from "./case-types/case-types-store";
import CustomFieldsStore from "./custom-fields/custom-fields-store";
import LanguageStore from "./language/language-store";
import ClaimsStore from "./claims/claims-store";
import AddressBookStore from "./address-book/address-book-store";
import { AppModeEnum } from './models';
import RecordingStore from "./recording/recording-store";
import SigningStore from "./signing/signing-store";
import WorkflowStore from "./offline-mode/client/workflow-store";
import OrganizationGroupStore from "./organization/group/organization-group-store";
var RootStore = /** @class */ (function () {
    function RootStore() {
        Object.defineProperty(this, "fieldsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "languageStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "caseTypesStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "claimsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "addressBookStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "recordingStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signingStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "workflowStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "organizationGroupStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "appMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: AppModeEnum.None
        });
        makeObservable(this);
        window.$RootStore = this;
        this.fieldsStore = new CustomFieldsStore();
        this.recordingStore = new RecordingStore();
        this.signingStore = new SigningStore();
        this.languageStore = new LanguageStore();
        this.addressBookStore = new AddressBookStore(this);
        this.claimsStore = new ClaimsStore(this);
        this.workflowStore = new WorkflowStore();
        this.caseTypesStore = new CaseTypesStore(this, this.fieldsStore, this.addressBookStore);
        this.organizationGroupStore = new OrganizationGroupStore();
        if (process.env.NODE_ENV === 'development') {
            this.setAppMode(AppModeEnum.OfflineWorkflow);
        }
    }
    Object.defineProperty(RootStore.prototype, "setAppMode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (appMode) {
            this.appMode = appMode;
        }
    });
    __decorate([
        observable
    ], RootStore.prototype, "appMode", void 0);
    __decorate([
        action
    ], RootStore.prototype, "setAppMode", null);
    return RootStore;
}());
export { RootStore };
var rootStore = new RootStore();
export default rootStore;
